const initialState = { code: "", isValid: false, hasBeenApplied: false };

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "UPDATE_APPLY_CODE_INPUT":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
